import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import HeaderComponent from "../../components/header";
import CaseStudiesComponent from "../../components/caseStudies";
import FooterComponent from "../../components/footer";
import HomeBanner from "../../components/homeBanner";
import GetInTouchComponent from "../../components/getInTouch";
import OurServicesComponent from "../../components/ourServices";
import OurClientSayComponent from "../../components/ourClientsSay";
import OurApproach from "../../components/ourApproach";
import OurCompaniesComponent from "../../components/ourCompanies";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "About") {
      navigate(`/aboutUs`);
    }
    if (section === "Blog") {
      navigate("/blog");
    }
    refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (location?.state?.scrollTo) {
      const section = location.state.scrollTo;
      setTimeout(() => {
        handleScrollToPortion(section);
      }, 100); // slight delay ensures DOM is ready
    }
  }, [location]);

  return (
    <>
      <HeaderComponent
        handleScrollToPortion={handleScrollToPortion}
        ref={refs.Home}
      />
      <HomeBanner
        handleScrollToPortion={handleScrollToPortion}
        ref={refs.Home}
      />
      <OurServicesComponent ref={refs.Services} />
      <OurApproach />
      <CaseStudiesComponent ref={refs["Case Studies"]} />
      <OurCompaniesComponent />
      <OurClientSayComponent ref={refs.Blog} />
      <GetInTouchComponent ref={refs.Contact} />
      <FooterComponent handleScrollToPortion={handleScrollToPortion} />
    </>
  );
};

export default LandingPage;
